<template>
  <form
    class="load_perm_container container_box_shadow flex-column"
    style="display: flex; justify-content: flex-start; height: 1100px"
    @submit.prevent="ePermiteSend()"
  >
    <h2 class="title" style="margin: 0px 0px 50px 0px">
      {{ $t("e_permit_tab.permit_history") }}
    </h2>

    <div class="ePermitClientType" v-if="!isLoadStaticData">
      <span @click="getStaticData(false)">{{
        $t("e_permit_tab.individual")
      }}</span>
      <span @click="getStaticData(true)">{{ $t("e_permit_tab.legal") }}</span>
    </div>

    <div class="form_block flex-row" v-if="isLoadStaticData">
      <!-- left_side -->
      <div class="left_side">
        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.select_country") }} </label>
          <div :class="`input_wrapper `">
            <select v-model="main.country" required>
              <option value="" disabled selected>Выберите опцию</option>
              <option v-for="el in countries" :value="el" :key="el">
                {{ el }}
              </option>
            </select>
          </div>
        </div>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.permit_type") }}</label>
          <div :class="`input_wrapper `">
            <select v-model="selected_permit_types" required>
              <option value="" disabled selected>Выберите опцию</option>
              <option v-for="el in permit_types" :value="el" :key="el">
                <span v-if="$i18n.locale === 'tm'">{{ el.tm }}</span>
                <span v-if="$i18n.locale === 'ru'">{{ el.ru }}</span>
                <span v-if="$i18n.locale === 'en'">{{ el.en }}</span>
              </option>
            </select>
          </div>
        </div>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.type_of_cargo") }}</label>
          <div :class="`input_wrapper `">
            <input
              class="form_box_shadow"
              v-model="main.type_of_cargo"
              type="text"
              required
            />
          </div>
        </div>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.container_number") }}</label>
          <div :class="`input_wrapper `">
            <input
              class="form_box_shadow"
              v-model="main.container_number"
              type="number"
              required
            />
          </div>
        </div>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.departure_date") }}</label>
          <div :class="`input_wrapper `">
            <input
              class="form_box_shadow"
              v-model="main.departure_date"
              type="date"
              required
            />
          </div>
        </div>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.return_date") }}</label>
          <div :class="`input_wrapper `">
            <input
              class="form_box_shadow"
              v-model="main.return_date"
              type="date"
              required
            />
          </div>
        </div>

        <!-- ================== -->
      </div>

      <!-- right_side -->
      <div class="right_side">
        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("car_tab.select_driver") }} </label>
          <div :class="`input_wrapper `">
            <select @change="handleDriverChange" required>
              <option value="" disabled selected>Выберите опцию</option>
              <option v-for="el in drivers" :value="el.id" :key="el.id">
                {{ el.name }} {{ el.surname }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="Object.keys(driverData).length != 0">
          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("driver_tab.name") }}</label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="driverData.name"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("driver_tab.surname") }}</label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="driverData.surname"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("driver_tab.patronymic") }}</label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="driverData.patronymic"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("driver_tab.driving_license_number") }}</label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="driverData.driving_license_number"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{
              $t("driver_tab.driving_license_expire_date")
            }}</label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="driverData.driving_license_expired_date"
                type="date"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{
              $t("driver_tab.driving_license_category")
            }}</label>
            <div :class="`input_wrapper `">
              <multiselect
                v-model="driverData.driving_licence_categories"
                :options="driving_licence_categories"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Выберите Категорию водительского удостоверения"
                :preselect-first="true"
              >
                <template #selection="{ values, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length"
                    v-show="!isOpen"
                    >{{ values.length }} выбрано
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <!-- ================== -->
      </div>
    </div>

    <div class="form_block flex-row" v-if="Object.keys(driverData).length != 0">
      <!-- left_side -->
      <div class="left_side">
        <h2
          class="title"
          style="margin: 30px 0px 0px 0px"
          v-if="Object.keys(driverData).length != 0"
        >
          {{ $t("e_permit_tab.car") }}
        </h2>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.select_car") }}</label>
          <div :class="`input_wrapper `">
            <select v-model="selectedCar" required>
              <option value="" disabled selected>Выберите опцию</option>
              <option v-for="el in transports" :value="el" :key="el.id">
                {{ el.plate_number }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="Object.keys(selectedCar).length != 0">
          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.car_brand") }} </label>
            <div :class="`input_wrapper `">
              <select v-model="selectedCar.brand" required>
                <option value="" disabled selected>Выберите опцию</option>
                <option v-for="el in brands" :value="el" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.car_number") }} </label>
            <div :class="`input_wrapper`">
              <input
                class="form_box_shadow"
                v-model="selectedCar.plate_number"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.card_number") }} </label>
            <div :class="`input_wrapper`">
              <input
                class="form_box_shadow"
                v-model="selectedCar.card_number"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.card_star_date") }} </label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="selectedCar.card_start_date"
                type="date"
                required
              />
            </div>
          </div>
        </div>
        <!-- ================== -->
      </div>

      <!-- right_side -->
      <div class="right_side">
        <h2
          class="title"
          style="margin: 30px 0px 0px 0px"
          v-if="Object.keys(driverData).length != 0"
        >
          {{ $t("e_permit_tab.trailer") }}
        </h2>

        <!-- Input -->
        <div class="label_input_block">
          <label for="">{{ $t("e_permit_tab.select_trailer") }}</label>
          <div :class="`input_wrapper `">
            <select v-model="selectedTrailer">
              <option value="" disabled selected>Выберите опцию</option>
              <option v-for="el in trailers" :value="el" :key="el.id">
                {{ el.plate_number }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="Object.keys(selectedTrailer).length != 0">
          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("trailer_tab.trailer_brand") }}</label>
            <div :class="`input_wrapper `">
              <select v-model="selectedTrailer.brand" required>
                <option value="" disabled selected>Выберите опцию</option>
                <option v-for="el in brands" :value="el" :key="el">
                  {{ el }}
                </option>
              </select>
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("trailer_tab.trailer_number") }} </label>
            <div :class="`input_wrapper`">
              <input
                class="form_box_shadow"
                v-model="selectedTrailer.plate_number"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.card_number") }} </label>
            <div :class="`input_wrapper`">
              <input
                class="form_box_shadow"
                v-model="selectedTrailer.card_number"
                type="text"
                required
              />
            </div>
          </div>

          <!-- Input -->
          <div class="label_input_block">
            <label for="">{{ $t("car_tab.card_star_date") }} </label>
            <div :class="`input_wrapper `">
              <input
                class="form_box_shadow"
                v-model="selectedTrailer.card_start_date"
                type="date"
                required
              />
            </div>
          </div>
        </div>
        <!-- ================== -->
      </div>
    </div>

    <div
      class="submit_button_box flex-row"
      v-if="isLoadStaticData"
      style="margin: 30px 0px 0px 0px !important"
    >
      <button class="submit_button" type="submit">
        {{ $t("load_permission_tab.save_button") }}
      </button>
    </div>
  </form>

  <PopupWindow
    v-if="this.$store.state.popupShow"
    :title="popupText.current.title"
    :message="popupText.current.message"
    :buttonText="popupText.current.buttonText"
    :redirectTabPathName="
      isLegal == '1' ? tabs.legalData : tabs.individualDataTab
    "
  />
</template>

<script>
import PopupWindow from "@/components/online_application/PopupWindow.vue";
import Multiselect from "vue-multiselect";
import MultiselectCSS from "/public/vue-multiselect.css";

export default {
  components: { Multiselect, MultiselectCSS, PopupWindow },

  props: {
    changeTab: "",
    tabs: {},
  },

  data() {
    return {
      isLegal: "",
      isLoadStaticData: false,

      main: {},
      client: {},
      drivers: [],
      countries: [],
      driving_licence_categories: [],
      brands: [],
      permit_types: [],

      driverData: {},
      transports: [],
      trailers: [],

      selectedCar: {},
      selectedTrailer: {},
      selected_permit_types: {},

      popupText: {
        success: {
          title: "Нет данных",
          message: "Заполните данные",
          buttonText: "Перейти",
        },
        failure: {
          title: "history_tab.failure.title",
          message: "history_tab.failure.message",
          buttonText: "history_tab.failure.buttonText",
        },
        current: {
          title: "",
          message: "",
          buttonText: "",
        },
      },
    };
  },

  methods: {
    getStaticData(isLegal) {
      this.isLegal = isLegal ? "1" : "0";
      this.$store.state.preLoader = true;

      window.axios
        .get(
          `${this.$store.state.backendRoutes.ePermitStaticData}/${this.isLegal}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        )
        .then((res) => {
          this.client = res.data.client;
          this.drivers = res.data.drivers;
          this.countries = res.data.countries;
          this.driving_licence_categories = res.data.driving_licence_categories;
          this.brands = res.data.brands;
          this.permit_types = res.data.permit_types;

          if (res.data.client.length === 0) {
            this.popupText.current = this.popupText.success;
            this.$store.state.popupShow = true;
          }
        })
        .catch(this.$store.state.axiosCatch)
        .finally(() => {
          this.$store.state.preLoader = false;
          this.isLoadStaticData = true;
        });
    },

    handleDriverChange(e) {
      if (e.target.options.selectedIndex > -1) {
        let i = e.target.options.selectedIndex - 1;

        this.getDriverData(this.drivers[i].id);
      }
    },

    getDriverData(id) {
      this.$store.state.preLoader = true;

      window.axios
        .get(`${this.$store.state.backendRoutes.ePermitTransportData}/${id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
        .then((res) => {
          this.driverData = res.data.driver;
          this.transports = res.data.transports;
          this.trailers = res.data.trailers;
        })
        .catch(this.$store.state.axiosCatch)
        .finally(() => {
          this.$store.state.preLoader = false;
        });
    },

    ePermiteSend() {
      this.$store.state.preLoader = true;

      let transportsList = [];

      let selectedCar = {
        ...this.selectedCar,
        is_transport: "1",
      };

      let selectedTrailer = {
        ...this.selectedTrailer,
        is_transport: "0",
      };

      transportsList.push(selectedCar);

      if (Object.keys(this.selectedTrailer).length != 0) {
        transportsList.push(selectedTrailer);
      }

      let data = {
        ...this.main,
        is_legal: this.isLegal,
        client: this.client,
        driver: this.driverData,
        transports: transportsList,
        permit_type: this.selected_permit_types.number,
        permit_description: this.selected_permit_types.tm,
      };

      axios
        .post(this.$store.state.backendRoutes.ePermitSend, data, {
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })
        .then((res) => {
          if (res.data.status) {
            this.$props.changeTab(this.$props.tabs.ePermitHistory);
          }
        })
        .catch(this.$store.state.axiosCatch)
        .finally(() => {
          this.$store.state.preLoader = false;
        });

      console.log(data);
    },
  },
};
</script>
